import { render, staticRenderFns } from "./ViewCreateDialog.vue?vue&type=template&id=4b2d5b88&scoped=true"
import script from "./ViewCreateDialog.vue?vue&type=script&lang=ts"
export * from "./ViewCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d5b88",
  null
  
)

export default component.exports